export const logPaymentBreakdownSummary = ({
  breakdown,
  actualAmount,
  currency,
  amountInSmallestUnit,
}) => {
  console.log("📋 Payment Breakdown Summary:");
  console.log("  Total items in breakdown:", breakdown.length);
  console.log("  Breakdown details:", JSON.stringify(breakdown, null, 2));
  console.log("  Total amount:", actualAmount, currency);
  console.log("  Amount in smallest unit:", amountInSmallestUnit);

  if (breakdown.length === 0) {
    console.error("❌ WARNING: Breakdown array is EMPTY!");
    console.error(
      "  This means no items will be saved to PaymentBreakdownTempEntity table"
    );
    console.error("  Check why breakdown items are not being added");
    return;
  }

  console.log("✅ Breakdown validation:");
  breakdown.forEach((item, index) => {
    console.log(`  [${index}] ${item.type}: ${item.description}`);
    console.log(
      `      feeId: ${item.feeId}, amount: ${item.amount} ${item.currency}`
    );
  });
};

export const buildPaymentOrderPayload = ({
  amountInSmallestUnit,
  currency,
  registrationId,
  email,
  conference,
  breakdown,
}) => ({
  amountInPaise: amountInSmallestUnit,
  currency,
  registrationId,
  email,
  conference,
  breakdown,
});

export const validatePaymentOrder = ({ order, razorpayKeyId }) => {
  if (!razorpayKeyId) {
    throw new Error(
      "Razorpay key is not configured. Please check your .env file."
    );
  }

  if (!order || typeof order !== "object") {
    throw new Error("Invalid order response format");
  }

  if (order.mapType === "java.util.HashMap" && order.empty === false && !order.id) {
    throw new Error(
      "Backend configuration error: The payment controller is not returning order data properly. Please check Razorpay keys in backend configuration."
    );
  }

  if (!order.id && !order.orderId) {
    console.error("Order response missing ID:", order);
    throw new Error(
      "Invalid order response - missing order ID. Response: " +
        JSON.stringify(order)
    );
  }
};

export const createValidatedPaymentOrder = async ({
  orderUrl,
  payload,
  registrationDbId,
  createPaymentOrder,
  razorpayKeyId,
}) => {
  console.log("🚀 Creating order at endpoint:", orderUrl);
  console.log("📤 Order Request Payload:", JSON.stringify(payload, null, 2));
  console.log("  - registrationId (registration identifier):", payload.registrationId);
  console.log("  - registrationDbId (registration table ID):", registrationDbId);
  console.log("  - amountInPaise:", payload.amountInPaise);
  console.log("  - currency:", payload.currency);
  console.log("  - breakdown.length:", payload.breakdown.length);

  const orderResult = await createPaymentOrder({
    orderUrl,
    payload,
  });

  console.log(
    "📥 Order Response Status:",
    orderResult.status,
    orderResult.statusText
  );

  if (!orderResult.ok) {
    return {
      ok: false,
      errorText: orderResult.errorText,
    };
  }

  const order = orderResult.order;

  console.log("✅ Order created successfully");
  console.log("📦 Order Response:", JSON.stringify(order, null, 2));
  console.log("🔑 Order identifiers:");
  console.log("  order.id (backend DB):", order.id);
  console.log("  order.orderId (Razorpay):", order.orderId);
  console.log(
    "📊 Breakdown should now be in PaymentBreakdownTempEntity table with orderId:",
    order.id
  );

  validatePaymentOrder({ order, razorpayKeyId });

  return {
    ok: true,
    order,
  };
};
